import axios from 'axios';
import {keyCodes} from '../commons'
import {convertLosslessNumber} from '../commons'
import { readAppSetting } from '../libs/appSettingUtils';
import store from '../store/index'

const LosslessJSON = require('lossless-json');

const CryptoJS = require('crypto-js');
const appSetting = readAppSetting();

const axiosX = axios.create({
  timeout: appSetting.timeout,
  baseURL: '/khLisApi',
});
axiosX.defaults.headers['Content-Type'] = 'application/json';

/**
 * sha256 加密
 * @param word
 * @param key
 * @returns {*}
 */
function encrypt(word, key) {
  const hashInBase64 = CryptoJS.HmacSHA256(word, key).toString(CryptoJS.enc.Hex);
  return hashInBase64;
}

//http request 拦截器
axiosX.interceptors.request.use(
  config => {
    let token = config.headers[keyCodes.TOKEN];
    //let userInfo = window.localStorage.userInfo;
    //userInfo = userInfo && JSON.parse(userInfo);

    const userInfo = store.state.userInfo;
    if (userInfo && userInfo.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      token = userInfo.token;
    }
    let method = config.method.toLowerCase();
    
    if (method != 'get') {
      if (!config.data) {
        config.data = {};
      }
      if (!config.data.userid && userInfo) {
        config.data.userid = userInfo.id;
      }
    }

    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'requestdigest': null,
      'token': token ? token : ''
    }

    let url = config.url;

    if (method == 'get') {
      let requestData = requestParamsToString(config.params);
      // 路径 "?" 后的字符串
      const questionIndex = (config.url).indexOf("?");
      if (questionIndex >= 0) {
        requestData = config.url.substring(questionIndex + 1) + (requestData.length > 0 ? ("&" + requestData) : "");
        url = url.substring(0, questionIndex); // 含?号
      }
      if (requestData) {
        config.url = url + "?" + requestData;
        config.params = undefined;
      }

      headers.requestdigest = encrypt(requestData, token ? token : '');
      headers['requestJson'] = encodeURIComponent(JSON.stringify(config.data));
    } else {
      headers.requestdigest = encrypt(JSON.stringify(config.data), token ? token : '');
    }
    config.headers = headers;

    if (method == 'post' || method == 'put') {
      config.data = 'requestJson=' + encodeURIComponent(JSON.stringify(config.data));
      // config.data = {requestJson: encodeURIComponent(JSON.stringify(config.data))};
    }
    // config.responseType == 'arraybuffer';
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//响应拦截器即异常处理
axiosX.interceptors.response.use(response => {
  if (response.data && response.config.responseType == 'arraybuffer') {
    let buffer = new Buffer(response.data, 'binary');
    let textdata = buffer.toString();
    //console.log(textdata);
    if(!textdata.trim()) {
      let err = new Error();
      err.message = "数据异常，请尝试重新登陆";
      return Promise.reject(err);
    }
    let jsondata = LosslessJSON.parse(textdata, convertLosslessNumber);
    response.data = jsondata;
  }
  return response;
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break
      case 401:
        err.message = '未授权，请登录'
        break
      case 403:
        err.message = '拒绝访问'
        break
      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break
      case 408:
        err.message = '请求超时'
        break
      case 500:
        err.message = '服务器内部错误'
        break
      case 501:
        err.message = '服务未实现'
        break
      case 502:
        err.message = '网关错误'
        break
      case 503:
        err.message = '服务不可用'
        break
      case 504:
        err.message = '网关超时'
        break
      case 505:
        err.message = 'HTTP版本不受支持'
        break
      default:
        err.message = `连接错误${err.response.status}`
    }
    // if (err.response.data && err.response.data.error){
    //     //   err.message = err.response.data.error;
    //     // }
  }
  // else {
  //   err.message='连接到服务器失败'
  // }
  //return Promise.resolve(err.response)
  return Promise.reject(err);
})

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, onSuccess = null, onFail = null) {
  axiosX.get(url, {
    data: params,
    params: params,
    responseType: 'arraybuffer'
  }).then(response => {
    if ($.isFunction(onSuccess)) {
      onSuccess(response.data);
    }
  }).catch(err => {
    if ($.isFunction(onFail)) {
      onFail(err);
    }
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}, onSuccess = null, onFail = null) {
  axiosX.post(url, data, {
    responseType: 'arraybuffer'
  }).then(response => {
    if ($.isFunction(onSuccess)) {
      onSuccess(response.data);
    }
  }).catch(err => {
    if ($.isFunction(onFail)) {
      onFail(err);
    }
  })
}

/**
 * 使用自定义的token
 * @param url
 * @param token
 * @param data
 * @returns {Promise<any>}
 */
export function postWithCustomToken(url, token, data = {}, onSuccess = null, onFail = null) {
  axiosX.post(url, data, {
    headers: {
      'token': token
    },
    responseType: 'arraybuffer'
  }).then(response => {
    if (!response.data) {
      throw Error('服务器返回的数据异常：为空');
    }
    if ($.isFunction(onSuccess)) {
      onSuccess(response.data);
    }
  }).catch(err => {
    if ($.isFunction(onFail)) {
      onFail(err);
    }
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}, onSuccess = null, onFail = null) {
  axiosX.put(url, data, {
    responseType: 'arraybuffer'
  }).then(response => {
    if ($.isFunction(onSuccess)) {
      onSuccess(response.data);
    }
  }).catch(err => {
    if ($.isFunction(onFail)) {
      onFail(err);
    }
  })

  // return new Promise((resolve, reject) => {
  //   axiosX.put(url, data, {
  //     responseType: 'arraybuffer'
  //   }).then(response => {
  //     resolve(response.data);
  //   }, err => {
  //     reject(err)
  //   })
  // })
}


// 将请求参数转为字符串，如：a=1&b=x
function requestParamsToString(params) {
  if (params == undefined) {
    return "";
  }
  if (params instanceof String) {
    return params;
  }
  const results = [];
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined) {
      results.push(k + "=" + v);
    }
  });

  return results.join("&");
}

export default {
  get,
  post,
  postWithCustomToken,
  put
}



// WEBPACK FOOTER //
// ./src/api/axiosX.js